import { render, staticRenderFns } from "./resume-row.vue?vue&type=template&id=4e5fb651&scoped=true&"
import script from "./resume-row.vue?vue&type=script&lang=js&"
export * from "./resume-row.vue?vue&type=script&lang=js&"
import style0 from "./resume-row.vue?vue&type=style&index=0&id=4e5fb651&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5fb651",
  null
  
)

export default component.exports